import type { Major } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

const EXCLUDED_KEYS = new Set(['careerPathRelevance']);

export const useAgentContext = (major?: Major) => {
  useRegisterAgentContext(
    major
      ? {
          kind: 'entity',
          description: 'The academic major the user is viewing',
          data: Object.fromEntries(Object.entries(major).filter(([k]) => !EXCLUDED_KEYS.has(k))),
        }
      : null,
  );
};
